// Formatting helpers shared by the usage page, tenant details and the paused banner.

const TIMEZONE = "Asia/Taipei";

const locale = (lng) => (lng === "en" ? "en-US" : "zh-TW");

export const formatNumber = (value, lng) =>
  Number(value || 0).toLocaleString(locale(lng));

// "2026-09" → "2026年9月" / "Sep 2026"
export const formatMonth = (month, lng) => {
  const [year, m] = month.split("-").map(Number);
  return new Intl.DateTimeFormat(locale(lng), {
    year: "numeric",
    month: lng === "en" ? "short" : "long",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, m - 1, 1)));
};

// Taiwan time, e.g. "2026年10月15日 09:30" / "Oct 15, 2026, 09:30"
export const formatDateTime = (iso, lng) =>
  new Intl.DateTimeFormat(locale(lng), {
    year: "numeric",
    month: lng === "en" ? "short" : "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: TIMEZONE,
  }).format(new Date(iso));

// Months from `earliest` to `current`, newest first.
export const monthRange = (earliest, current) => {
  const months = [];
  let [year, month] = current.split("-").map(Number);
  for (;;) {
    const value = `${year}-${String(month).padStart(2, "0")}`;
    if (value < earliest) break;
    months.push(value);
    month -= 1;
    if (month === 0) {
      month = 12;
      year -= 1;
    }
  }
  return months;
};

// Whole percent, or null when there is no quota yet.
export const usagePercent = (messageCount, quota) =>
  quota ? Math.round((messageCount / quota) * 100) : null;

// "2027-06-30" → "2027年6月30日" / "Jun 30, 2027"
export const formatDate = (date, lng) => {
  if (!date) return "";
  const [year, m, d] = date.split("-").map(Number);
  return new Intl.DateTimeFormat(locale(lng), {
    year: "numeric",
    month: lng === "en" ? "short" : "long",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, m - 1, d)));
};

// Months from `start` for `count` months, oldest first.
export const monthsFrom = (start, count) => {
  const months = [];
  let [year, month] = start.split("-").map(Number);
  for (let i = 0; i < count; i += 1) {
    months.push(`${year}-${String(month).padStart(2, "0")}`);
    month += 1;
    if (month === 13) {
      month = 1;
      year += 1;
    }
  }
  return months;
};
